import { render } from "./Gifts_manage.vue?vue&type=template&id=3bf57042"
import script from "./Gifts_manage.vue?vue&type=script&lang=js"
export * from "./Gifts_manage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__